var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1846 561L1846 589",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1846.5,
    cy: 556.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1841.99 556.19C1841.99 552.283 1845.29 549.117 1849.36 549.117C1849.94 549.117 1850.51 549.184 1851.06 549.308C1849.74 548.48 1848.19 548 1846.52 548C1841.81 548 1838 551.806 1838 556.5C1838 561.194 1841.81 565 1846.52 565C1848.81 565 1850.89 564.093 1852.43 562.62C1851.49 563.032 1850.45 563.263 1849.36 563.263C1845.29 563.263 1841.99 560.096 1841.99 556.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1855.4 555.6L1855.37 553.146L1853.54 554.719L1851.3 554.056L1852.11 556.337L1850.77 558.381L1853.1 558.218L1854.5 560.144L1855.13 557.763L1857.34 556.909L1855.4 555.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch6);
export default __webpack_public_path__ + "static/media/church_6.7c6e560dd4deb8debe05620786675725.svg";
export { ForwardRef as ReactComponent };